import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator";
import { rfqQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { css } from "styled-components";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

rfqQuoteDetailsQuoteLineCalculatorStyles.resetButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.cancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

rfqQuoteDetailsHeaderStyles.deleteQuoteButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

rfqQuoteDetailsHeaderStyles.submitQuoteButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

rfqQuoteDetailsHeaderStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #fff !important;
            }
            ul {
                background: #fff;
            }
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton = {
    mergeCss: true,
    css: css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationCancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationApplyAllButton = {
    mergeCss: true,
    css: css`
        width: 100%;
    `,
};
